import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyABc9T7l3acL-lArg3wklemI4bABwMEkps",
  authDomain: "komodo-sdk.firebaseapp.com",
  projectId: "komodo-sdk",
  storageBucket: "komodo-sdk.appspot.com",
  messagingSenderId: "784580222071",
  appId: "1:784580222071:web:ab8715b1e3724b005bfa72",
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
